<!-- Toolbar -->
<nav class="navbar navbar-expand-lg navbar-light sticky-top text-white navbar-z-index-fixed">
  <div class="container-fluid d-flex px-lg-5 h-100">
    <a class="navbar-brand p-0 m-0" [routerLink]="['/']">
      <img src="../../../assets/logo_blanco.png" alt="Logo Blanco Aliwell" height="32" class="d-inline-block">
    </a>
    <button #navbarToggler class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="toggler-icon top-bar"></span>
      <span class="toggler-icon middle-bar"></span>
      <span class="toggler-icon bottom-bar"></span>
    </button>
    <div class="collapse navbar-collapse mt-3 mt-md-3 mt-lg-0 gap-2 gap-xl-5 justify-content-end" id="navbarNav">
      <ul class="navbar-nav gap-2 gap-xl-5">
        <ng-container *ngIf="this.customerStatus == 1">
          <li class="nav item" *ngFor="let item of sitemapUrls">
            <a class="nav-link text-white"
               aria-current="page"
               routerLinkActive="active-link"
               [routerLinkActiveOptions]="{exact: true}"
               (click)="goToNewPage(item.url)">
              {{item.name}}
            </a>
          </li>
        </ng-container>
        <li class="nav item" *ngIf="this.customerStatus == 1 && hasDentalMonitoringDoctorId">
          <a class="nav-link text-white" (click)="goToMySmartSTLRequest()">Solicitudes Smart STL</a>
        </li>
        <li class="nav item dropdown" *ngIf="this.customerStatus == 1">
          <p class="nav-link dropdown-toggle text-white" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Categorías
          </p>
          <ul class="dropdown-menu">
            <li *ngFor="let cat of mycategories"><a (click)="categoryClicked(cat)" class="dropdown-item">{{cat.categoryName}}</a></li>
          </ul>
        </li>
        <li class="nav item">
          <a class="nav-link text-white" aria-current="page" routerLinkActive="active-link" (click)="openExternalLink()">
            {{resourceLabel}}
          </a>
        </li>
        <li class="nav item dropdown">
          <p class="nav-link dropdown-toggle text-white" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-user-circle"></i>
            Hola! {{userName}}
          </p>
          <ul class="dropdown-menu">
            <li *ngIf="this.customerStatus == 1"><a class="dropdown-item" (click)="goToMyProfile()">Mi perfil</a></li>
            <li *ngIf="this.customerStatus == 1"><a class="dropdown-item" (click)="goToMyPurchases()">Mis compras</a></li>
            <li *ngIf="this.customerStatus == 1"><a class="dropdown-item" (click)="goToMyStock()">Mis productos</a></li>
            <li><a class="dropdown-item" (click)="changePasswordClicked()">Cambiar contraseña</a></li>
            <li><a class="dropdown-item" (click)="onHandleClickLogout()">Cerrar sesión</a></li>
          </ul>
        </li>
        <li class="nav item" *ngIf="isOnOpenPayProcess()">
          <p #shoppingCartButton class="nav-link text-white">
            ({{shoppingCartCount}})
            <i class="fa fa-shopping-cart"></i>
            Carrito
          </p>
        </li>
        <li class="nav item" *ngIf="this.customerStatus == 1 && !isOnOpenPayProcess()">
          <p #shoppingCartButton class="nav-link text-white" id="shoppingCartButton" data-bs-toggle="collapse" data-bs-target="#navbarNav" (click)="onShoppingCartClick($event)" [disabled]="isOnOpenPayProcess()">
            ({{shoppingCartCount}})
            <i class="fa fa-shopping-cart"></i>
            Carrito
          </p>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Router Outlet -->
<div class="content">
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
